export default function HoldbackSection() {
  const steps = [
    {
      num: "01",
      title: "Insurance Issues ACV Check",
      desc: "Your carrier sends the first check — the Actual Cash Value. This is the depreciated value of your old roof. Most homeowners think this is the full payout.",
      highlight: false,
    },
    {
      num: "02",
      title: "Holdback Funds Are Reserved",
      desc: "Simultaneously, the carrier sets aside the Recoverable Depreciation — your holdback. This money sits in reserve, waiting for you to claim it. It does NOT expire immediately, but you have a limited window.",
      highlight: true,
    },
    {
      num: "03",
      title: "Repairs Are Completed",
      desc: "Once your roof is installed, you have proof of completion. This is the trigger that unlocks the holdback funds. Without this documentation, the money stays with the carrier.",
      highlight: false,
    },
    {
      num: "04",
      title: "You Submit Completion Docs",
      desc: "A final invoice, photos, and completion certificate are submitted to the carrier. RidgeCap GC handles all of this for you — most homeowners don't know this step even exists.",
      highlight: false,
    },
    {
      num: "05",
      title: "Second Check Arrives",
      desc: "The carrier releases the holdback funds. This is your money — money you paid premiums for. The average second check is $8,000–$15,000. RidgeCap GC makes sure it gets to you.",
      highlight: true,
    },
  ];

  return (
    <section id="holdback" className="py-24 bg-[#1a1a2e]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#f97316]/20 text-[#f97316] text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-full mb-5">
            <i className="ri-lock-unlock-line"></i>
            Hidden Holdback Funds
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-white leading-tight mb-4">
            There Are <span className="text-[#f97316]">Two Checks</span> in Every Roofing Claim.<br className="hidden md:block" />
            Most Homeowners Only Get One.
          </h2>
          <p className="text-white/55 text-base max-w-2xl mx-auto leading-relaxed">
            The holdback system is built into nearly every homeowner&apos;s insurance policy — but carriers don&apos;t advertise it. Here&apos;s exactly how it works and why most people leave that money behind.
          </p>
        </div>

        {/* Steps */}
        <div className="flex flex-col gap-4 mb-16">
          {steps.map((step) => (
            <div
              key={step.num}
              className={`rounded-xl p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center gap-6 transition-all duration-200 ${
                step.highlight
                  ? "bg-[#f97316] text-white"
                  : "bg-white/8 border border-white/10 text-white"
              }`}
            >
              <div
                className={`text-4xl font-black flex-shrink-0 ${
                  step.highlight ? "text-white/40" : "text-[#f97316]"
                }`}
              >
                {step.num}
              </div>
              <div className="flex-1">
                <h3
                  className={`font-bold text-lg mb-2 ${
                    step.highlight ? "text-white" : "text-white"
                  }`}
                >
                  {step.title}
                </h3>
                <p
                  className={`text-sm leading-relaxed ${
                    step.highlight ? "text-white/85" : "text-white/60"
                  }`}
                >
                  {step.desc}
                </p>
              </div>
              {step.highlight && (
                <div className="flex-shrink-0">
                  <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full">
                    <i className="ri-arrow-right-line text-white text-lg"></i>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Bottom Callout */}
        <div className="bg-white/5 border border-white/15 rounded-2xl p-8 md:p-12 text-center">
          <div className="text-6xl font-black text-[#f97316] mb-3">98%</div>
          <h3 className="text-white font-black text-2xl mb-3">
            of Roofing Claims Have Unclaimed Depreciation
          </h3>
          <p className="text-white/55 text-base max-w-xl mx-auto mb-8 leading-relaxed">
            If you&apos;ve had a roofing claim in the last 6–12 months and haven&apos;t received a second check, there&apos;s a very good chance your holdback funds are still waiting. Don&apos;t let that deadline pass.
          </p>
          <div className="flex justify-center">
            <a
              href="#cta"
              className="inline-flex items-center gap-2 bg-[#f97316] hover:bg-[#ea6c0a] text-white font-bold px-8 py-4 rounded-md text-sm whitespace-nowrap cursor-pointer transition-colors duration-200"
            >
              Check If You Have Unclaimed Funds
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
